import { render } from "./NewLecturesListPage.vue?vue&type=template&id=51dae138&scoped=true"
import script from "./NewLecturesListPage.vue?vue&type=script&lang=js"
export * from "./NewLecturesListPage.vue?vue&type=script&lang=js"

import "./NewLecturesListPage.vue?vue&type=style&index=0&id=51dae138&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51dae138"]])

export default __exports__